// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip--2OnHb"};